const templateQrScanner = () => {
  const qrCode = window.qrcode;
  const video = document.createElement("video");
  const canvasElement = document.getElementById("qr-canvas");

  if (canvasElement) {
    
    const canvas = canvasElement.getContext("2d");
    const qrResult = document.getElementById("qr-result");
    const outputData = document.getElementById("outputData");
    const btnScanQR = document.getElementById("btn-scan-qr");
    let scanning = false;

    /**
     * Callback
     * 
     * @param {*} res 
     */

    qrCode.callback = (res) => {
      if (res) {
        outputData.value = res;
        scanning = false;
        video.srcObject.getTracks().forEach((track) => {
          track.stop();
        });
        qrResult.hidden = false;
        canvasElement.hidden = true;
        btnScanQR.hidden = false;

        if (outputData.value) {
          window.location.href = window.location.origin + "/scanner/?ticket=" + res;
        }
      }
    };

    btnScanQR.onclick = () => {
      navigator.mediaDevices.getUserMedia({ video: { facingMode: "environment" } }).then(function (stream) {
        scanning = true;
        qrResult.hidden = true;
        btnScanQR.hidden = true;
        canvasElement.hidden = false;
        video.setAttribute("playsinline", true); // required to tell iOS safari we don't want fullscreen
        video.srcObject = stream;
        video.play();
        tick();
        scan();
      });
    };

    /**
     * Tick
     */

    function tick() {
      canvasElement.height = video.videoHeight;
      canvasElement.width = video.videoWidth;
      canvas.drawImage(video, 0, 0, canvasElement.width, canvasElement.height);
      scanning && requestAnimationFrame(tick);
    }
    /**
     * Scan 
     */

    function scan() {
      try {
        qrcode.decode();
      } catch (e) {
        setTimeout(scan, 300);
      }
    }
  }
};

export default templateQrScanner;
